const COLORS = {
  SUCCESS: '#52c41a',
  ERROR: '#ff4d4f',
  WARNING: '#faad14'
};

export default COLORS;
